var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEurFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_2968",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_2968)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#043CAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0572 4.27624L14 4.0001L14.9428 4.27624L14.6667 3.33343L14.9428 2.39062L14 2.66677L13.0572 2.39062L13.3333 3.33343L13.0572 4.27624ZM13.0572 17.6097L14 17.3336L14.9428 17.6097L14.6666 16.6669L14.9428 15.7241L14 16.0003L13.0572 15.7241L13.3333 16.6669L13.0572 17.6097ZM20.6667 10.6671L19.7238 10.9432L20 10.0004L19.7238 9.05762L20.6667 9.33376L21.6095 9.05762L21.3333 10.0004L21.6095 10.9432L20.6667 10.6671ZM6.39052 10.9432L7.33333 10.6671L8.27614 10.9432L7.99999 10.0004L8.27614 9.05762L7.33333 9.33376L6.39052 9.05762L6.66666 10.0004L6.39052 10.9432ZM19.7735 7.3336L18.8307 7.60974L19.1068 6.66693L18.8307 5.72412L19.7735 6.00026L20.7163 5.72412L20.4401 6.66693L20.7163 7.60974L19.7735 7.3336ZM7.28368 14.2762L8.22649 14.0001L9.16929 14.2762L8.89315 13.3334L9.16929 12.3906L8.22649 12.6668L7.28368 12.3906L7.55982 13.3334L7.28368 14.2762ZM17.3333 4.89317L16.3905 5.16931L16.6667 4.2265L16.3905 3.28369L17.3333 3.55983L18.2761 3.28369L18 4.2265L18.2761 5.16931L17.3333 4.89317ZM9.72385 16.7167L10.6667 16.4405L11.6095 16.7167L11.3333 15.7739L11.6095 14.8311L10.6667 15.1072L9.72385 14.8311L9.99999 15.7739L9.72385 16.7167ZM19.7735 14.0001L18.8307 14.2762L19.1068 13.3334L18.8307 12.3906L19.7735 12.6668L20.7163 12.3906L20.4402 13.3334L20.7163 14.2762L19.7735 14.0001ZM7.28366 7.60974L8.22647 7.3336L9.16928 7.60974L8.89314 6.66693L9.16928 5.72412L8.22647 6.00026L7.28366 5.72412L7.5598 6.66693L7.28366 7.60974ZM17.3333 16.4405L16.3905 16.7167L16.6667 15.7739L16.3905 14.8311L17.3333 15.1072L18.2761 14.8311L18 15.7739L18.2761 16.7167L17.3333 16.4405ZM9.72385 5.16931L10.6667 4.89317L11.6095 5.16931L11.3333 4.2265L11.6095 3.28369L10.6667 3.55983L9.72385 3.28369L9.99999 4.2265L9.72385 5.16931Z",
    fill: "#FFD429"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurFlag);
export default __webpack_public_path__ + "static/media/eur-flag.2b3dfe1f5a64665a7f579b74905ff3e1.svg";
export { ForwardRef as ReactComponent };